import React from 'react';

import { PieChart } from 'react-minimal-pie-chart';
import CountUp from 'react-countup';

import { PieChartData } from '../../../Interface/Hook/PieChart/PieChartDataDTOInterface';
import { PieChartTotals } from '../../../Interface/Hook/PieChart/PieChartTotalsDTOInterface';

const getPercentage = (part: number, total: number): number => Math.round((part / total) * 100);

interface Props {
    title: string;
    data?: PieChartData[];
    totals?: PieChartTotals;
}

const DonutChart: React.FC<Props> = (props: Props) => {
    const { title, data, totals } = props;

    if (typeof data === 'undefined' || typeof totals === 'undefined') {
        return null;
    }

    return (
        <>
            <h3>{title}</h3>
            <div className="pie-chart">
                <div className="pie-chart__details">
                    <PieChart data={data} animate={true} lineWidth={15} className="pie-chart__details-chart" />
                    <span className="pie-chart__details-total">
                        <CountUp end={getPercentage(totals.match, totals.total)} duration={1} />%
                    </span>
                </div>
                <div className="pie-chart__index">
                    {data.map((scope, index) => (
                        <div key={index} className={'pie-chart__index__item'}>
                            <span
                                className="pie-chart__index__item__color-indicator"
                                style={{ backgroundColor: scope.color }}
                            />
                            {scope.title}
                            <br />
                            <span className="pie-chart__index__item__information">
                                {getPercentage(scope.value, totals.total)}% | {scope.value} uit {totals.total} regels
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default DonutChart;
